/** Room booking statuses, as stored by the server (RoomBooking::STATUSES). */
export type BookingStatus = "booked" | "checked_in" | "checked_out" | "cancelled";

export const BOOKING_STATUSES: BookingStatus[] = ["booked", "checked_in", "checked_out", "cancelled"];

/** Booked and checked-in bookings hold the room; cancelled / checked-out ones free it. */
export const ACTIVE_STATUSES = ["booked", "checked_in"];

/** Mirrors RoomBooking::STATUS_TRANSITIONS; replaced by the server's copy once the list loads */
export const DEFAULT_TRANSITIONS: Record<string, string[]> = {
  booked: ["checked_in", "cancelled"],
  checked_in: ["checked_out", "booked"],
  checked_out: ["checked_in"],
  cancelled: ["booked"],
};

export const BOOKING_STATUS_LABEL: Record<string, string> = {
  booked: "Booked",
  checked_in: "Checked in",
  checked_out: "Checked out",
  cancelled: "Cancelled",
};

export const BOOKING_STATUS_CLASS: Record<string, string> = {
  booked: "bg-amber-100 text-amber-800 border border-amber-200",
  checked_in: "bg-blue-100 text-blue-700 border border-blue-200",
  checked_out: "bg-emerald-100 text-emerald-700 border border-emerald-200",
  cancelled: "bg-stone-100 text-stone-500 border border-stone-200",
};

export const bookingStatusLabel = (s: string) => BOOKING_STATUS_LABEL[s] || s.replace(/_/g, " ");
export const bookingStatusClass = (s: string) => BOOKING_STATUS_CLASS[s] || "bg-stone-100 text-stone-600 border border-stone-200";

/** "2026-09-22T00:00:00.000000Z" -> "2026-09-22" (booking dates are whole days) */
export const d10 = (s?: string | null) => (s || "").slice(0, 10);

/** Whole days between two YYYY-MM-DD dates */
export const dayDiff = (a: string, b: string) => Math.round((Date.parse(a) - Date.parse(b)) / 86_400_000);

/** YYYY-MM-DD plus n days */
export const addDays = (day: string, n: number) => {
  const d = new Date(`${day}T00:00:00`);
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
